import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule, Routes } from '@angular/router';
import { TableModule } from 'primeng/table';
import { ToastModule } from 'primeng/toast';
import { CalendarModule } from 'primeng/calendar';
import { SliderModule } from 'primeng/slider';
import { MultiSelectModule } from 'primeng/multiselect';
import { ContextMenuModule } from 'primeng/contextmenu';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { DropdownModule } from 'primeng/dropdown';
import { ProgressBarModule } from 'primeng/progressbar';
import { InputTextModule } from 'primeng/inputtext';
import { FileUploadModule } from 'primeng/fileupload';
import { ToolbarModule } from 'primeng/toolbar';
import { RatingModule } from 'primeng/rating';
import { RadioButtonModule } from 'primeng/radiobutton';
import { InputNumberModule } from 'primeng/inputnumber';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmationService } from 'primeng/api';
import { MessageService } from 'primeng/api';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { AuthGuard } from '../../../appCommon/AuthGuard/auth.guard';
import { MenuItems, Modules } from 'src/app/appCommon/Enums/enum';
import { CheckboxModule } from 'primeng/checkbox';
import { InputMaskModule } from 'primeng/inputmask';
import { TooltipModule } from 'primeng/tooltip';
import { SidebarModule } from 'primeng/sidebar';
import { PasswordModule } from 'primeng/password';
import { DividerModule } from "primeng/divider";
import { SelectButtonModule } from 'primeng/selectbutton';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { TabViewModule } from 'primeng/tabview';
import { MatTabsModule } from '@angular/material/tabs';
import { SharedModule } from '../../shared/shared.module';
import {ChartModule} from 'primeng/chart';
import {PanelModule} from 'primeng/panel';
import {CardModule} from 'primeng/card';
import { MeasuresComponent } from 'src/app/appWeb/pages/measures/components/measures/measures.component';
import { caseInsensitiveMatcher } from 'src/app/appCommon/Pipes/LowerCaseUrlSerializer';

const routes: Routes = [
  {
    path: '', component: MeasuresComponent,
    children: [
      { path: '', redirectTo: Modules.Measures },
      { matcher:caseInsensitiveMatcher(Modules.Measures), canActivate: [AuthGuard],data: { allowedRoles: [MenuItems.Measure] }, component: MeasuresComponent },
    ]
  }
];

@NgModule({
  declarations: [
    MeasuresComponent
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    ButtonModule,
    FormsModule,
    HttpClientModule,
    ToastModule,
    TableModule,
    CalendarModule,
    SliderModule,
    MultiSelectModule,
    ContextMenuModule,
    DialogModule,
    DropdownModule,
    ProgressBarModule,
    InputTextModule,
    FileUploadModule,
    ToolbarModule,
    RatingModule,
    RadioButtonModule,
    InputNumberModule,
    ConfirmDialogModule,
    InputTextareaModule,
    CheckboxModule,
    ReactiveFormsModule,
    InputMaskModule,
    TooltipModule,
    SidebarModule,
    PasswordModule,
    DividerModule,
    SelectButtonModule,
    ToggleButtonModule,
    SharedModule,
    TabViewModule,
    MatTabsModule,
    ChartModule,
    PanelModule,
    ReactiveFormsModule,
    CardModule 
  ],
  providers: [ConfirmationService, MessageService, AuthGuard],
})

export class MeasuresModule { }
